var render = function render(){var _vm=this,_c=_vm._self._c;return _c('r-focus-layout',{staticClass:"r-loading",attrs:{"center":true}},[_c('div',{staticClass:"c-box"},[_c('dot-loader',{attrs:{"color":"#347fa8"}}),_c('div',{staticClass:"subtitle"},[_vm._v("Loading")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }